import React from "react";
import GlobalRegionsController from "../components/network/GlobalRegionsController";
import GraphDataController from "../components/network/GraphDataController";
import GraphEventsController from "../components/network/GraphEventsController";
import GraphSelectionController from "../components/network/GraphSelectionController";
import GraphSettingsController from "../components/network/GraphSettingsController";
import NetworkUserInterface from "../components/network/NetworkUserInterface";
import WithWebGL from "../components/WithWebGL";
import {usePageTitle} from "../hooks/usePageTitle";
import SigmaProvider from "../utils/sigmaProvider";
import "../css/network.css";


const TheCellMap = React.memo(() => {
  usePageTitle("Network View");

  return (
    <WithWebGL>
      <SigmaProvider>
        <GraphSettingsController/>
        <GraphEventsController/>
        <GraphDataController/>
        <GraphSelectionController/>
        <GlobalRegionsController/> {/* Draw the colurful enrichment regions*/}

        <NetworkUserInterface/>
      </SigmaProvider>
    </WithWebGL>
  );
});

export default TheCellMap;
